import { defineStore } from 'pinia'

export const useContentCardStore = defineStore('contentCard', () => {
  const { $braze } = useNuxtApp()
  const offerCards = ref<BrazeCard[]>([])

  const showNotification = computed(() => {
    return offerCards.value?.some((card) => !card.viewed)
  })

  function init() {
    setOfferCards()
  }

  function updateOfferCards() {
    $braze.sdk.requestContentCardsRefresh(
      () => {
        $braze.debugLogger('Content cards refreshed')
      },
      () => {
        $braze.debugLogger('Content cards refresh failed')
      },
    )
    setOfferCards()
  }

  function setOfferCards() {
    offerCards.value =
      $braze.sdk
        .getCachedContentCards()
        ?.cards?.filter((card) => card.extras['feed_type'] === 'offer' && !card.isControl) ?? []
  }

  return {
    offerCards,
    showNotification,
    setOfferCards,
    init,
    updateOfferCards,
  }
})
